import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TicketStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M21.25 6C21.25 5.30964 20.6904 4.75 20 4.75H4C3.30964 4.75 2.75 5.30964 2.75 6V8.83789C4.18325 9.17655 5.25 10.4633 5.25 12C5.25 13.5366 4.18314 14.8224 2.75 15.1611V18C2.75 18.6904 3.30964 19.25 4 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V15.1611C19.8169 14.8224 18.75 13.5366 18.75 12C18.75 10.4633 19.8168 9.17655 21.25 8.83789V6ZM22.75 9.5C22.75 9.91421 22.4142 10.25 22 10.25C21.0335 10.25 20.25 11.0335 20.25 12C20.25 12.9665 21.0335 13.75 22 13.75C22.4142 13.75 22.75 14.0858 22.75 14.5V18C22.75 19.5188 21.5188 20.75 20 20.75H4C2.48122 20.75 1.25 19.5188 1.25 18V14.5C1.25 14.0858 1.58579 13.75 2 13.75C2.96649 13.75 3.75 12.9665 3.75 12C3.75 11.0335 2.96649 10.25 2 10.25C1.58579 10.25 1.25 9.91421 1.25 9.5V6C1.25 4.48122 2.48122 3.25 4 3.25H20C21.5188 3.25 22.75 4.48122 22.75 6V9.5Z"
				fill="currentColor"
			/>
			<path d="M9.75 4V20H8.25V4H9.75Z" fill="currentColor" />
		</svg>
	);
}

TicketStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TicketStrokeIcon;
